import { render, staticRenderFns } from "./CourseLive.vue?vue&type=template&id=e7c4f0d0&scoped=true"
import script from "./CourseLive.vue?vue&type=script&lang=js"
export * from "./CourseLive.vue?vue&type=script&lang=js"
import style0 from "./CourseLive.vue?vue&type=style&index=0&id=e7c4f0d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c4f0d0",
  null
  
)

export default component.exports